module.exports = __webpack_public_path__ + "img/Edelstahlgelaender.24f16bb2.jpg";